export default __webpack_public_path__ + "static/media/error-image.bb351cb8.png";